const InsuranceUtils = require('./insurance.utils');
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();

const isDesktop = () => Odigeo.SessionScope.flow === 'desktop';

const isDP = () => Odigeo.SessionScope.flowProduct === 'dp';

const getAB = () => websiteConfigCollection.getAB();

const getFlexibilityDisruptionDesktop = ({flexibilityDisruptionDesktop = 1} = {}) => flexibilityDisruptionDesktop;

const getABTestPartition = () => getFlexibilityDisruptionDesktop(getAB());

const areABTestsEnabled = () => getABTestPartition() >= 3;

module.exports = {
    isEnabled: () => isDesktop() && !isDP() && areABTestsEnabled() && InsuranceUtils.isInsuranceAvailable(),
};
